export enum DropStatus {
  Upcoming = 1,
  Finished,

  Next = 999, // front-end added value
}

export enum FreeDropSounds {
  DropStart = 'dropStart',
  DropScene = 'dropScene',
  ClaimSuccess = 'claimSuccess',
  ClaimError = 'claimError'
}

export enum FreeDropTheme {
  Gift = 0,
  RedEnvelope = 1
}

export enum FreeDropNotificationType {
  Intro = 'intro',
  DropIn30Minutes = 'dropIn30Minutes',
  DropIn2Minutes = 'dropIn2Minutes',
  LevelUnlocked = 'levelUnlocked'
}
